import axios from 'axios';
import { handleApiError } from './errorHandler';

//const API_BASE_URL = 'http://192.168.1.241:3000/v1'; // for Development
const API_BASE_URL = 'https://coreauth-api.osca-solutions.com/v1'; // Production URL
const APPLICATION_ID = 'b57974ed-269e-11f0-af50-0242ac120002';

interface AuthResponse {
  token?: string;
  user?: {
    id: string;
    email: string;
    mfaEnabled: boolean;
  };
  requiresMFA?: boolean;
  mfaMethod?: 'TOTP' | 'EMAIL_OTP' | 'SMS_OTP';
  tempToken?: string;
}

interface MFAVerificationResponse {
  message: string;
  token: string;
}

export const authService = {
  getGoogleAuthUrl: async (referralCode?: string): Promise<string> => {
    try {
      const url = new URL(`${API_BASE_URL}/auth/google/url`);
      url.searchParams.set('application_id', APPLICATION_ID);
      if (referralCode) {
        url.searchParams.set('referral_code', referralCode);
      }
      
      const response = await axios.get(url.toString());
      return response.data.url;
    } catch (error: any) {
      const apiError = handleApiError(error);
      throw new Error(apiError.message);
    }
  },
  register: async (email: string, password: string, referralCode?: string): Promise<AuthResponse> => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/register`, {
        email,
        password,
        application_id: APPLICATION_ID,
        additional_data: referralCode ? { referralCode } : undefined
      });
      return response.data;
    } catch (error: any) {
      const apiError = handleApiError(error);
      throw new Error(apiError.message);
    }
  },

  login: async (email: string, password: string): Promise<AuthResponse> => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        email,
        password,
        application_id: APPLICATION_ID
      });
      return response.data;
    } catch (error: any) {
      const apiError = handleApiError(error);
      throw new Error(apiError.message);
    }
  },

  verifyMFA: async (token: string, tempToken: string, type: string): Promise<MFAVerificationResponse> => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/mfa/${type === 'TOTP' ? 'totp' : 'otp'}/verify`,
        { token: token },
        {
          headers: { Authorization: `Bearer ${tempToken}` }
        }
      );
      return response.data;
    } catch (error: any) {
      const apiError = handleApiError(error);
      throw new Error(apiError.message);
    }
  },

  requestOTP: async (type: 'EMAIL_OTP' | 'SMS_OTP', destination: string, tempToken: string): Promise<void> => {
    try {
      await axios.post(
        `${API_BASE_URL}/mfa/otp/request`,
        { type, destination },
        {
          headers: { Authorization: `Bearer ${tempToken}` }
        }
      );
    } catch (error: any) {
      const apiError = handleApiError(error);
      throw new Error(apiError.message);
    }
  },

  fetchUserData: async (token: string): Promise<AuthResponse['user']> => {
    try {
      const response = await axios.get(`${API_BASE_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data.user;
    } catch (error: any) {
      const apiError = handleApiError(error);
      throw new Error(apiError.message);
    }
  },

  logout: async (token: string): Promise<void> => {
    try {
      await axios.post(`${API_BASE_URL}/auth/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error: any) {
      const apiError = handleApiError(error);
      throw new Error(apiError.message);
    }
  }
};